import { Inject, inject, Injectable, PLATFORM_ID } from '@angular/core';
import { AuthOptions, OidcSecurityService, UserDataResult } from 'angular-auth-oidc-client';
import { BehaviorSubject, filter, map, Observable, shareReplay, take, tap } from 'rxjs';
import { IUserDataInfo, User } from '../../models/user';
import { isPlatformBrowser } from '@angular/common';


@Injectable({
  providedIn: 'root',
})
export class NsideIdentityService {
  private readonly oidcService: OidcSecurityService = inject(OidcSecurityService);

  constructor(
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  checkAuth() {
    if (isPlatformBrowser(this.platformId)) {
      return this.oidcService.checkAuth();
    }
    return new Observable<any>(); // Return an empty observable when on the server
  }

  login(redirectRoute: string) {
    if (isPlatformBrowser(this.platformId)) {
      const authOption: AuthOptions = {
        redirectUrl: redirectRoute
      }
      this.oidcService.authorize();
    }
  }

  logout() {
    if (isPlatformBrowser(this.platformId)) {
      this.oidcService.logoff().subscribe((result) => console.log(result));
    }
  }

  getAccessToken() {
    return (isPlatformBrowser(this.platformId)) ? this.oidcService.getAccessToken() : null;
  }

  loggedIn$ = this.oidcService.isAuthenticated$;

  user$: Observable<User> = this.oidcService.userData$.pipe(
    filter((v) => Boolean(v)),
    map((usr: UserDataResult) => usr.userData),
    tap(() => this.loaded()),
    shareReplay(1)
  );

  userId$ = this.user$.pipe(
    map((user) => {
      const userData = user.user_data?.filter((f) => f?.length > 0).map((m) => {
        try {
          return JSON.parse(m) as IUserDataInfo;
        } catch {
          return null;
        }
      }).filter((item) => item?.Name.toLowerCase().includes('nsideid'));

      return userData?.length > 0 ? userData[0] : { Name: 'ERROR', Value: null } as IUserDataInfo;
    }),
    map((v) => (this.isNumeric(v?.Value) ? v?.Value as number : v?.Value as string)),
    take(1)
  );

  private loadingSubject = new BehaviorSubject<boolean>(false);

  loaded() {
    this.loadingSubject.next(false);
  }

  isNumeric(value: any): boolean {
    return typeof value === 'number';
  }
}
